document.addEventListener("DOMContentLoaded", function() {
  
  var submitButtons = document.querySelectorAll('form button[type="submit"], form input[type="submit"]');
  var numButtons = submitButtons.length;
  console.log("Numero di form da processare con iubenda:", numButtons);
  
  submitButtons.forEach(function(button) {
      var form = button.closest('form');
      if (form) {
          var formId = form.id;
          var checkCnt = 0;
          var checkboxesWithDataConsPreference = form.querySelectorAll('input[type="checkbox"][data-cons-preference]');
          checkboxesWithDataConsPreference.forEach(function(checkbox) {
              checkCnt++;
          });
              
          button.addEventListener('click', function(event) {
            console.log("test");
            if(checkCnt>=1 && form.checkValidity()){
                event.preventDefault();
            
                if (typeof _iub !== 'undefined') {
                    var subjectId   = 'undefined';
                    var emailValue  = 'undefined';
                    var emailInputs = form.querySelectorAll('input[type="email"]');
                    emailInputs.forEach(function(emailInput) {
                        emailValue = emailInput.value;
                        subjectId = emailValue.toLowerCase().replace(/\W/g, '-');
                    });
                    console.log(subjectId);
                    
                    // Synchronous call, it's sent right when this function is executed
                    _iub.cons_instructions.push(["submit", {
                        writeOnLocalStorage: false,
                        form: { 
                            selector: document.getElementById(formId),
                        },
                        consent: {
                            subject:{ id: subjectId, email: emailValue },
                            legal_notices: [
                                { identifier: 'privacy_policy', }
                            ],
                        }
                    },{
                        success: function(response) { 
                            console.log(response);
                            form.submit();
                        }, 
                        error: function(response) { 
                            console.log(response); 
                        }
                    }])
                } else {
                    console.log("_iub undefined");
                    form.submit();
                }
            
            } else {
                console.log("form error");
            }
          }) 
          
      }
  });

});